module.exports = __webpack_public_path__ + "img/conversionDomonetization.1f3fb89f.svg";